import React, {Component} from 'react';
import ButtonConfirmDelete from './ButtonConfirmDelete'

class SystemHubButtonDelete extends Component {
  render() {
    const {hub, onDelete} = this.props
    const content = `Chắc chắn xoá hub ${hub.Name}?`
    return <ButtonConfirmDelete title="Xoá hub" content={content} object={hub} onOk={onDelete}/>
  }
}

export default SystemHubButtonDelete;



// WEBPACK FOOTER //
// ./src/components/SystemHubButtonDelete.js